export const movieList = [
  {
    id: "m-01",
    title: "夜行列车",
    category: "movie",
    year: "2024",
    region: "中国大陆",
    director: "陈景行",
    cast: "张远、林小满、周牧",
    duration: "118 分钟",
    rating: 8.6,
    views: 284000,
    updatedAt: "2024-11-08",
    tags: ["悬疑", "剧情", "公路"],
    summary: "一列午夜发车的绿皮火车上，七名陌生乘客各自藏着一个不能说出口的秘密。",
    description:
      "暴雨封路的夜晚，开往边境的最后一班列车缓缓启动。列车员老赵发现，车上的七名乘客彼此之间竟然有着千丝万缕的联系。随着车厢灯光一次次熄灭，一段被刻意掩埋的往事被逐层揭开。影片以密闭空间叙事串联起三段时空，用克制的镜头语言描摹普通人在命运岔路口的犹豫与选择。",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20film%20poster%20artwork%20of%20a%20single%20night%20train%20window%20glowing%20warm%20amber%20in%20deep%20dark%20rain%20soaked%20frame%2C%20grainy%20analog%20texture%2C%20muted%20earth%20tones%2C%20minimal%20editorial%20composition%2C%20no%20text%2C%20high%20detail&width=600&height=900&seq=cov-night-train&orientation=portrait",
  },
  {
    id: "m-02",
    title: "山海之间",
    category: "movie",
    year: "2023",
    region: "中国大陆",
    director: "罗启明",
    cast: "何秀兰、陈屿、宋知远",
    duration: "132 分钟",
    rating: 8.9,
    views: 512000,
    updatedAt: "2024-10-22",
    tags: ["剧情", "家庭", "乡土"],
    summary: "守了一辈子渔港的母亲，在儿子决定卖掉老屋的那个夏天，重新走了一遍海岸线。",
    description:
      "东南沿海的小渔村即将整体搬迁，独居多年的阿婆拒绝在协议上签字。从城市赶回来的儿子带着合同与不安，试图说服母亲。台风来临前的三天里，母子二人沿着海岸线修补渔网、祭拜祖坟、拜访老邻居，也第一次真正谈起了那个多年不提的名字。影片用大量自然光与长镜头，记录下一代人与一片海之间缓慢的告别。",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20film%20poster%20artwork%20of%20a%20lone%20fishing%20boat%20on%20a%20misty%20sea%20at%20dawn%20with%20mountains%20silhouetted%20behind%2C%20soft%20golden%20haze%2C%20film%20grain%2C%20warm%20muted%20palette%2C%20minimal%20composition%2C%20no%20text&width=600&height=900&seq=cov-mountain-sea&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Wide%20cinematic%20landscape%20of%20a%20quiet%20fishing%20village%20harbor%20at%20golden%20dawn%2C%20mist%20over%20dark%20water%2C%20weathered%20wooden%20boats%2C%20warm%20amber%20sunlight%20breaking%20through%20clouds%2C%20moody%20atmospheric%20film%20still%2C%20grainy%20texture%2C%20no%20text&width=1600&height=900&seq=bg-mountain-sea&orientation=landscape",
  },
  {
    id: "m-03",
    title: "长巷灯火",
    category: "movie",
    year: "2022",
    region: "中国香港",
    director: "郑婉仪",
    cast: "梁家宁、苏文清、何伯",
    duration: "105 分钟",
    rating: 8.2,
    views: 198000,
    updatedAt: "2024-09-15",
    tags: ["生活", "温情", "都市"],
    summary: "一条即将拆迁的老巷里，六户人家的灯火在最后一个冬天彼此照亮。",
    description:
      "旺角深处的一条老巷，住着开凉茶铺的夫妻、独居的退休裁缝、刚搬来的年轻乐队和守了三十年报摊的阿伯。拆迁通知贴上墙面的那天，巷口那盏坏了半年的路灯突然被修好了。影片没有激烈的冲突，只用一日三餐、柴米油盐和一盏盏亮起的窗灯，把一座城市的体温留在胶片里。",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20film%20poster%20artwork%20of%20a%20narrow%20old%20city%20alley%20with%20warm%20orange%20window%20lights%20reflecting%20on%20wet%20pavement%20at%20night%2C%20neon%20glow%20bokeh%2C%20grainy%20film%20texture%2C%20nostalgic%20warm%20palette%2C%20no%20text&width=600&height=900&seq=cov-alley-lights&orientation=portrait",
  },
  {
    id: "m-04",
    title: "逆光之城",
    category: "movie",
    year: "2024",
    region: "韩国",
    director: "朴成焕",
    cast: "李在勋、韩素英、崔民在",
    duration: "124 分钟",
    rating: 8.4,
    views: 436000,
    updatedAt: "2024-11-02",
    tags: ["犯罪", "悬疑", "都市"],
    summary: "一名被停职的刑警在追查一起旧案时，发现所有线索都指向自己二十年前的搭档。",
    description:
      "港口城市连环失踪案重启调查，被迫停职的刑警姜度贤私下展开追踪。他在废弃的仓库里找到一本写满陌生人姓名的笔记本，最后一页却是自己的名字。影片以冷峻的城市夜景和对白极少的追逐段落，讲述一个人如何在正义与私情之间被逼到墙角。",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20film%20poster%20artwork%20of%20a%20solitary%20figure%20standing%20in%20a%20backlit%20urban%20underpass%20at%20night%2C%20long%20shadows%2C%20teal%20and%20amber%20contrast%2C%20grainy%20analog%20texture%2C%20tense%20atmosphere%2C%20no%20text&width=600&height=900&seq=cov-backlight-city&orientation=portrait",
  },
  {
    id: "m-05",
    title: "风起南岸",
    category: "movie",
    year: "2023",
    region: "中国大陆",
    director: "许亦然",
    cast: "沈鹿、顾清和、白露",
    duration: "112 分钟",
    rating: 7.9,
    views: 267000,
    updatedAt: "2024-08-30",
    tags: ["爱情", "剧情", "海岛"],
    summary: "岛屿气象站的观测员，与每年只停留一个雨季的摄影师，写了七年的天气预报。",
    description:
      "南岸岛的雨季长达三个月，气象站只有一名值守员。每年这个时候，一位摄影师都会带着旧相机住进岛上的民宿。两人用气象记录本和照片交换彼此的生活，却始终没有约定过下一次见面。风停了，船开了，那些写在纸上的风向与湿度，成了最克制的告白。",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20film%20poster%20artwork%20of%20a%20windy%20island%20coastline%20with%20tall%20grass%20bending%20under%20pale%20golden%20afternoon%20light%2C%20distant%20lighthouse%2C%20soft%20haze%2C%20film%20grain%2C%20romantic%20muted%20palette%2C%20no%20text&width=600&height=900&seq=cov-south-coast-wind&orientation=portrait",
  },
  {
    id: "m-06",
    title: "荒原信使",
    category: "movie",
    year: "2021",
    region: "欧美",
    director: "Ethan Cole",
    cast: "Marcus Reed、Nora Vale",
    duration: "137 分钟",
    rating: 8.1,
    views: 176000,
    updatedAt: "2024-07-11",
    tags: ["冒险", "西部", "公路"],
    summary: "一位年迈的邮差骑着旧摩托穿越荒原，只为把最后一封信送到地图上消失的小镇。",
    description:
      "邮政线路取消前的最后一个月，老邮差接下了一封没有准确地址的信。他穿越干涸的河床、废弃的加油站与无人看守的牧场，在路上遇到形形色色的旅人。影片以宽阔的西部风景与缓慢的节奏，讲一个关于承诺与抵达的故事。",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20film%20poster%20artwork%20of%20a%20lone%20rider%20on%20a%20dusty%20road%20crossing%20a%20vast%20dry%20desert%20plain%20at%20sunset%2C%20orange%20dust%20haze%2C%20long%20shadow%2C%20grainy%20film%20still%2C%20western%20mood%2C%20no%20text&width=600&height=900&seq=cov-wasteland-messenger&orientation=portrait",
  },
  {
    id: "m-07",
    title: "无声证词",
    category: "movie",
    year: "2024",
    region: "中国大陆",
    director: "周立川",
    cast: "韩松、叶蓁、罗兵",
    duration: "129 分钟",
    rating: 8.7,
    views: 389000,
    updatedAt: "2024-10-05",
    tags: ["犯罪", "法庭", "悬疑"],
    summary: "一场没有目击者的案件，唯一的证人是位听障女孩，她的证词让所有人沉默。",
    description:
      "城中村的一起坠楼案进入庭审，控辩双方各执一词。关键证人是一位十九岁的听障女孩，她的手语翻译在庭上屡次被质疑。随着辩护律师一步步追查，监控死角、被删改的通话记录与一份迟到三年的诊断书浮出水面。影片把法庭的每一次停顿都拍成了重量。",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20film%20poster%20artwork%20of%20an%20empty%20courtroom%20bench%20lit%20by%20a%20single%20narrow%20beam%20of%20light%2C%20dust%20particles%20in%20the%20air%2C%20deep%20shadows%2C%20grainy%20monochrome%20warm%20tone%2C%20dramatic%20minimal%20composition%2C%20no%20text&width=600&height=900&seq=cov-silent-testimony&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Atmospheric%20cinematic%20wide%20shot%20of%20an%20empty%20old%20courthouse%20hall%20with%20tall%20windows%20casting%20long%20light%20beams%20across%20wooden%20benches%2C%20dust%20in%20the%20air%2C%20amber%20and%20deep%20brown%20tones%2C%20grainy%20film%20still%2C%20no%20text&width=1600&height=900&seq=bg-silent-testimony&orientation=landscape",
  },
  {
    id: "m-08",
    title: "第七个夏天",
    category: "movie",
    year: "2022",
    region: "日本",
    director: "中村凉太",
    cast: "佐藤遥、井上圭、森川千夏",
    duration: "108 分钟",
    rating: 8.3,
    views: 221000,
    updatedAt: "2024-06-18",
    tags: ["青春", "成长", "夏日"],
    summary: "高考结束的那个夏天，四个少年决定在废弃泳池里办一场只演一次的露天电影。",
    description:
      "小镇的旧泳池即将被填平，四个刚毕业的少年偷偷拿到了钥匙。他们用借来的投影仪、坏掉的音响和自己拍的短片，筹备一场只属于这个夏天的放映会。蝉鸣、汽水、被晒得发烫的水泥地和说不出口的告别，构成了十七岁的最后一帧画面。",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20film%20poster%20artwork%20of%20an%20empty%20outdoor%20swimming%20pool%20in%20summer%20with%20blinding%20sunlight%20and%20long%20shadows%2C%20faded%20pale%20tiles%2C%20nostalgic%20warm%20yellow%20tone%2C%20grainy%20film%20texture%2C%20no%20text&width=600&height=900&seq=cov-seventh-summer&orientation=portrait",
  },
  {
    id: "m-09",
    title: "铁轨尽头",
    category: "movie",
    year: "2020",
    region: "中国大陆",
    director: "白皓",
    cast: "姜野、罗小雨",
    duration: "116 分钟",
    rating: 7.8,
    views: 143000,
    updatedAt: "2024-05-24",
    tags: ["公路", "剧情", "旅途"],
    summary: "一对多年未见的父女沿废弃铁路线自驾三千公里，去取回一辆卖掉的旧车。",
    description:
      "父亲把家里最后一辆旧车卖掉后，女儿才知道买家在三千公里外。两人不得不一起上路。沿途的加油站、小镇旅馆和生锈的铁轨，让那些年没说出口的话慢慢有了出口。影片用公路片的结构，完成了一次笨拙而真诚的和解。",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20film%20poster%20artwork%20of%20rusted%20railway%20tracks%20disappearing%20into%20golden%20dry%20grassland%20at%20dusk%2C%20a%20small%20car%20silhouette%20far%20away%2C%20warm%20amber%20haze%2C%20grainy%20film%20texture%2C%20no%20text&width=600&height=900&seq=cov-end-of-tracks&orientation=portrait",
  },
  {
    id: "m-10",
    title: "拾荒者手记",
    category: "movie",
    year: "2023",
    region: "欧美",
    director: "Camille Roux",
    cast: "Luc Moreau、Ana Petit",
    duration: "121 分钟",
    rating: 8.5,
    views: 98000,
    updatedAt: "2024-09-02",
    tags: ["剧情", "社会", "人文"],
    summary: "一位靠回收旧物为生的老人，用捡来的相片拼出了半座城市的记忆。",
    description:
      "在城市边缘的垃圾回收站，老人每天整理被人丢弃的物件，把冲洗出来的旧照片分类保存。一个来拍纪录片的年轻人闯入了他的生活，也让这些陌生人的面孔重新被认领。影片安静、缓慢，却有着极强的后劲。",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20film%20poster%20artwork%20of%20scattered%20old%20photographs%20and%20worn%20objects%20on%20a%20weathered%20wooden%20table%2C%20soft%20side%20light%2C%20dusty%20sepia%20tones%2C%20shallow%20depth%20of%20field%2C%20grainy%20texture%2C%20no%20text&width=600&height=900&seq=cov-scavenger-notes&orientation=portrait",
  },
  {
    id: "m-11",
    title: "深巷面馆",
    category: "movie",
    year: "2024",
    region: "中国大陆",
    director: "邵一平",
    cast: "冯大勇、柳月、小满",
    duration: "96 分钟",
    rating: 7.6,
    views: 312000,
    updatedAt: "2024-11-12",
    tags: ["生活", "喜剧", "美食"],
    summary: "一家只做六碗面的小馆子，来了个非要拜师学艺的年轻人。",
    description:
      "老周的面馆开在巷子最深处，每天只做六碗面，卖完就关门。一个找不到工作的年轻人赖在店里不肯走，从洗碗开始学起。两个人围着一口汤锅吵吵闹闹，也把这条街上的人情冷暖煮进了汤里。",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20film%20poster%20artwork%20of%20a%20steaming%20bowl%20of%20noodles%20on%20a%20small%20wooden%20stall%20counter%20at%20night%2C%20warm%20lantern%20glow%2C%20rising%20steam%2C%20grainy%20film%20texture%2C%20cozy%20amber%20palette%2C%20no%20text&width=600&height=900&seq=cov-noodle-shop&orientation=portrait",
  },
  {
    id: "m-12",
    title: "白露为霜",
    category: "movie",
    year: "2021",
    region: "中国台湾",
    director: "林知远",
    cast: "温静、陈柏舟",
    duration: "118 分钟",
    rating: 8.0,
    views: 87000,
    updatedAt: "2024-04-09",
    tags: ["文艺", "爱情", "慢生活"],
    summary: "节气更替的十二个月里，两个错过彼此的人在同一个茶馆反复相遇。",
    description:
      "小镇茶馆的老板娘每年只在白露这天开门迎客，一个旅人恰好每年都会路过。十二个节气，十二次短暂的交谈，两人从不问对方的名字。影片以四季实景与节气字幕串联，像一篇安静的散文。",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20film%20poster%20artwork%20of%20a%20quiet%20tea%20house%20window%20with%20morning%20frost%20on%20the%20glass%2C%20soft%20pale%20light%2C%20dried%20flowers%20in%20a%20ceramic%20vase%2C%20grainy%20analog%20texture%2C%20muted%20warm%20neutral%20tones%2C%20no%20text&width=600&height=900&seq=cov-white-dew&orientation=portrait",
  },
  {
    id: "m-13",
    title: "回声实验",
    category: "movie",
    year: "2024",
    region: "欧美",
    director: "Owen Blake",
    cast: "Iris Lane、Tom Harrow",
    duration: "134 分钟",
    rating: 8.8,
    views: 468000,
    updatedAt: "2024-11-16",
    tags: ["科幻", "悬疑", "烧脑"],
    summary: "一项能回放过去七秒声音的实验，意外录到了尚未发生的对话。",
    description:
      "声学实验室的年轻研究员在调试设备时，捕捉到一段本不该存在的声音。随着实验推进，回放的时间窗口越来越长，也越来越难以控制。她逐渐意识到，自己听到的可能是七分钟后、七天后，甚至七年前的自己。影片以精准的音效设计构建出令人窒息的悬疑感。",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20film%20poster%20artwork%20of%20circular%20sound%20wave%20ripples%20glowing%20amber%20inside%20a%20dark%20laboratory%20chamber%2C%20reflective%20surfaces%2C%20sci%20fi%20minimal%20composition%2C%20grainy%20film%20texture%2C%20no%20text&width=600&height=900&seq=cov-echo-experiment&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Wide%20cinematic%20shot%20of%20a%20dark%20acoustic%20laboratory%20with%20concentric%20amber%20light%20rings%20glowing%20on%20the%20walls%20and%20a%20lone%20silhouette%20at%20a%20console%2C%20volumetric%20haze%2C%20sci%20fi%20atmosphere%2C%20grainy%20film%20still%2C%20no%20text&width=1600&height=900&seq=bg-echo-experiment&orientation=landscape",
  },
  {
    id: "m-14",
    title: "归乡者",
    category: "movie",
    year: "2019",
    region: "中国大陆",
    director: "秦牧",
    cast: "段国梁、许素琴、秦书言",
    duration: "142 分钟",
    rating: 9.1,
    views: 602000,
    updatedAt: "2024-03-21",
    tags: ["剧情", "历史", "家族"],
    summary: "离家四十年的老人回到北方村庄，只为在祖屋拆除前找回一块刻着名字的青砖。",
    description:
      "上世纪七十年代离开村庄的老人，在八十岁这年独自坐火车回来。村口的老槐树还在，祖屋已经列入拆迁名单。他要找的那块青砖，刻着全家人的名字。影片以极简的对白和大量固定镜头，把一代人的沉默与牵挂铺陈得格外漫长。",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20film%20poster%20artwork%20of%20an%20elderly%20man%20silhouette%20standing%20before%20an%20old%20brick%20village%20house%20in%20pale%20winter%20light%2C%20bare%20tree%20branches%2C%20cold%20muted%20amber%20tones%2C%20grainy%20film%20texture%2C%20no%20text&width=600&height=900&seq=cov-homecomer&orientation=portrait",
  },
  {
    id: "m-15",
    title: "潮汐之间",
    category: "movie",
    year: "2024",
    region: "中国大陆",
    director: "温书言",
    cast: "江沐、宋时雨",
    duration: "110 分钟",
    rating: 8.0,
    views: 154000,
    updatedAt: "2024-09-24",
    tags: ["爱情", "剧情", "海岛"],
    summary: "一座每天只被潮水连接两次的沙洲，住着两个都不肯先开口的人。",
    description:
      "沙洲上的灯塔需要每天维护，守塔人和来写生的画家轮班相处。涨潮时他们被困在岛上，退潮时才想起各自还有另一段生活。影片用潮汐时刻表串起两个人的四个季节，克制地讲一段没有承诺的感情。",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20film%20poster%20artwork%20of%20a%20lighthouse%20on%20a%20narrow%20sandbar%20surrounded%20by%20calm%20shallow%20water%20at%20pale%20dawn%2C%20soft%20golden%20mist%2C%20grainy%20analog%20texture%2C%20muted%20warm%20palette%2C%20no%20text&width=600&height=900&seq=cov-between-tides&orientation=portrait",
  },
  {
    id: "m-16",
    title: "雪线之上",
    category: "movie",
    year: "2022",
    region: "中国大陆",
    director: "高原",
    cast: "岳鹏、卓玛",
    duration: "126 分钟",
    rating: 8.4,
    views: 189000,
    updatedAt: "2024-08-18",
    tags: ["冒险", "剧情", "登山"],
    summary: "两名登山向导在暴风雪中失去联络，剩下的那个人必须决定是否继续向上。",
    description:
      "春季登山季，两位合作十年的向导带一支业余队伍冲顶。风雪提前到来，队伍分散，通讯中断。影片用纪实感的镜头拍出高原的呼吸声，也拍出人在极限环境里对同伴的信任与怀疑。",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20film%20poster%20artwork%20of%20two%20tiny%20climbers%20crossing%20a%20bright%20snow%20ridge%20under%20a%20huge%20pale%20amber%20sky%2C%20wind%20blown%20snow%20dust%2C%20grainy%20film%20texture%2C%20cold%20minimal%20composition%2C%20no%20text&width=600&height=900&seq=cov-above-snowline&orientation=portrait",
  },
  {
    id: "m-17",
    title: "终点站",
    category: "movie",
    year: "2023",
    region: "韩国",
    director: "金泰旭",
    cast: "朴正河、尹素拉",
    duration: "117 分钟",
    rating: 8.3,
    views: 245000,
    updatedAt: "2024-07-05",
    tags: ["犯罪", "悬疑", "都市"],
    summary: "一辆末班公交连续七天在同一站台停下，而站牌上的地名十年前就已注销。",
    description:
      "公交司机发现末班车的行车记录仪里多出一段不存在的路线。他开始在夜里沿着那条路线行驶，沿途上车的乘客都说着同一件事。影片把城市交通网络拍成一张巨大的谜面。",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20film%20poster%20artwork%20of%20an%20empty%20city%20bus%20at%20a%20lone%20dark%20bus%20stop%20at%20night%2C%20headlights%20cutting%20through%20light%20fog%2C%20amber%20street%20glow%2C%20grainy%20film%20texture%2C%20tense%20mood%2C%20no%20text&width=600&height=900&seq=cov-last-stop&orientation=portrait",
  },
  {
    id: "m-18",
    title: "街角书店",
    category: "movie",
    year: "2021",
    region: "日本",
    director: "佐藤直树",
    cast: "松本航、森川千夏",
    duration: "102 分钟",
    rating: 8.2,
    views: 112000,
    updatedAt: "2024-06-12",
    tags: ["生活", "温情", "治愈"],
    summary: "一家只卖旧书的店铺，店主有个奇怪的规定：买书前必须聊十分钟。",
    description:
      "街角书店没有招牌，进门先坐下喝茶。店主会根据客人的谈话推荐一本书，从不卖错。一个每周都来却从不买书的女孩，让这个规矩第一次被打破。",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20film%20poster%20artwork%20of%20a%20small%20old%20bookshop%20window%20at%20dusk%20with%20stacked%20books%20and%20a%20warm%20reading%20lamp%2C%20soft%20amber%20glow%2C%20grainy%20analog%20texture%2C%20cozy%20muted%20palette%2C%20no%20text&width=600&height=900&seq=cov-corner-bookshop&orientation=portrait",
  },
  {
    id: "m-19",
    title: "双城七日",
    category: "movie",
    year: "2024",
    region: "中国香港",
    director: "郑婉仪",
    cast: "梁家宁、林嘉",
    duration: "108 分钟",
    rating: 7.7,
    views: 203000,
    updatedAt: "2024-10-14",
    tags: ["爱情", "都市", "剧情"],
    summary: "七天之内，两个人在两座城市里不断错过同一班船。",
    description:
      "因为一份需要双方签字的合同，两个人开始在两个城市之间往返。航班延误、手机没电、码头临时封闭，所有的小意外都恰好让他们差一步遇见。第七天，他们终于在同一个候船厅坐下了。",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20film%20poster%20artwork%20of%20a%20ferry%20terminal%20waiting%20hall%20at%20night%20with%20empty%20seats%20and%20warm%20fluorescent%20glow%20reflecting%20on%20wet%20floor%2C%20grainy%20film%20texture%2C%20urban%20melancholy%2C%20no%20text&width=600&height=900&seq=cov-two-cities&orientation=portrait",
  },
  {
    id: "m-20",
    title: "沉默的港口",
    category: "movie",
    year: "2020",
    region: "欧美",
    director: "Daniel Frost",
    cast: "Ryan Cole、Eva Marsh",
    duration: "131 分钟",
    rating: 8.5,
    views: 167000,
    updatedAt: "2024-05-08",
    tags: ["犯罪", "剧情", "悬疑"],
    summary: "港口连续三个月没有货船靠岸，海关稽查员却每天都在登记一艘不存在的船。",
    description:
      "小港的货运量骤减，稽查员例行核对单据时发现异常。当他开始追查，所有相关的人都选择了沉默。影片用灰调的海雾与长镜头，写一个被利益与恐惧同时封住嘴的小镇。",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20film%20poster%20artwork%20of%20an%20empty%20foggy%20cargo%20harbor%20at%20grey%20dawn%20with%20silhouetted%20cranes%20and%20still%20water%2C%20muted%20amber%20grey%20tones%2C%20grainy%20film%20texture%2C%20no%20text&width=600&height=900&seq=cov-silent-harbor&orientation=portrait",
  },
  {
    id: "m-21",
    title: "春分出逃",
    category: "movie",
    year: "2023",
    region: "中国大陆",
    director: "白皓",
    cast: "姜野、罗小雨、周航",
    duration: "104 分钟",
    rating: 7.9,
    views: 231000,
    updatedAt: "2024-09-30",
    tags: ["青春", "公路", "成长"],
    summary: "三个高三学生在春分那天借了一辆车，去看一场没有票的演出。",
    description:
      "模拟考结束后的春分，三个少年决定出逃二十四小时。他们带着一箱橘子、一张旧地图和各自的烦恼上路。天亮的时分，他们并没有到达目的地，但有些话说出口了。",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20film%20poster%20artwork%20of%20a%20small%20car%20driving%20along%20an%20empty%20country%20road%20at%20spring%20sunrise%20with%20blossom%20trees%20and%20warm%20golden%20light%20flare%2C%20grainy%20film%20texture%2C%20nostalgic%20palette%2C%20no%20text&width=600&height=900&seq=cov-spring-escape&orientation=portrait",
  },
  {
    id: "m-22",
    title: "末班渡轮",
    category: "movie",
    year: "2019",
    region: "中国台湾",
    director: "林知远",
    cast: "温静、陈柏舟、许素琴",
    duration: "113 分钟",
    rating: 8.6,
    views: 141000,
    updatedAt: "2024-04-26",
    tags: ["剧情", "家庭", "文艺"],
    summary: "父亲最后一次开渡轮的那晚，船上只有女儿一个乘客。",
    description:
      "经营了三十年的渡轮线路即将停航。退休前的最后一班船，父亲特意绕了一段远路。女儿坐在船头，想起小时候每天坐这条船上学的日子。影片几乎没有配乐，只有引擎声与水声。",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20film%20poster%20artwork%20of%20a%20small%20ferry%20boat%20crossing%20calm%20water%20at%20sunset%20with%20a%20warm%20amber%20reflection%20trail%20and%20distant%20mountain%20silhouette%2C%20grainy%20film%20texture%2C%20quiet%20mood%2C%20no%20text&width=600&height=900&seq=cov-last-ferry&orientation=portrait",
  },
];